import { render, staticRenderFns } from "./AutoManufacture.vue?vue&type=template&id=8536de48&scoped=true&"
import script from "./AutoManufacture.vue?vue&type=script&lang=js&"
export * from "./AutoManufacture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8536de48",
  null
  
)

export default component.exports